import { PardotFieldSearchableSelectionTable } from '../../general/pardot-fields';
import React from 'react';
export const TagsPardotFieldsTab = ({ index, sonarObjectId }) => {
    const targetUri = `v2/Tags/${sonarObjectId}/pardot/fields`;
    return React.createElement(PardotFieldSearchableSelectionTable, { parentIndex: index, showParents: true, uri: targetUri });
};
